import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/icons/map.png'
import _imports_1 from '../assets/icons/mappoint.svg'


const _hoisted_1 = { class: "max-w-1440px mx-auto <sm:mt-40px" }
const _hoisted_2 = { class: "flex <sm:block" }
const _hoisted_3 = { class: "sm:hidden w-full px-50px h-195px overflow-hidden relative z-1" }
const _hoisted_4 = { class: "<sm:hidden pl-95px <xl:pl-50px <700:pl-25px py-75px <lg:py-30px flex w-full z-2 relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_accent_button = _resolveComponent("accent-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_0,
          class: "absolute h-full object-cover w-600px top-0 left-0 -z-1"
        }, null, -1)),
        _createVNode(_component_accent_button, { class: "flex-none mt-35px h-26px" }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("a", {
              href: "https://yandex.ru/maps/-/CCUu6-EV2B",
              target: "_blank"
            }, "Перейти на карту", -1)
          ])),
          _: 1
        }),
        _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"row mt-25px\"><img class=\"w-20px h-30px\" src=\"" + _imports_1 + "\"><div class=\"text-14px ml-12px\"> г. Королев, мкр Юбилейный, ул. Лесная<br> дом 14Б, офис 447 </div></div><div class=\"flex justify-between text-14px mt-30px\"><a href=\"tel:+79254182128\" class=\"\">+7 925 418 21 28</a><a href=\"mailto:support@e-rko.ru\" class=\"underline hover:text-hex-6664D6\">support@e-rko.ru</a></div>", 2))
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-none <sm:pl-50px <sm:text-12px <sm:leading-20px <sm:mr-0 mr-100px <xl:mr-50px <700:mr-30px pl-122px <xl:pl-85px <lg:pl-50px <lg:text-14px <lg:leading-20px mt-45px <sm:mt-20px text-22px leading-30px" }, [
        _createTextVNode(" © E-RKO"),
        _createElementVNode("br"),
        _createTextVNode(" 2019-2021"),
        _createElementVNode("br"),
        _createTextVNode(" Все права защищены"),
        _createElementVNode("br")
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_accent_button, { class: "flex-none mt-12px h-26px" }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("a", {
              href: "https://yandex.ru/maps/-/CCUu6-EV2B",
              target: "_blank"
            }, "Перейти на карту", -1)
          ])),
          _: 1
        }),
        _cache[4] || (_cache[4] = _createStaticVNode("<img class=\"w-35px h-50px &lt;lg:w-20px &lt;lg:h-30px ml-120px &lt;xl:ml-80px &lt;700:ml-30px &lt;1150:ml-40px\" src=\"" + _imports_1 + "\"><div class=\"ml-30px &lt;lg:ml-13px text-22px &lt;lg:text-14px &lt;lg:leading-20px leading-30px\"> г. Королев, мкр Юбилейный, ул. Лесная<br> дом 14Б, офис 447<br><br><a href=\"tel:+79254182128\" class=\"mr-20px\">+7 925 418 21 28</a><a href=\"mailto:support@e-rko.ru\" class=\"underline hover:text-hex-6664D6\">support@e-rko.ru</a></div><img src=\"" + _imports_0 + "\" class=\"-z-1 absolute top-0 left-0 h-full w-full object-cover\">", 3))
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mb-50px mt-55px <lg:mt-20px <xl:px-85px <lg:px-50px px-122px" }, [
      _createElementVNode("a", {
        class: "underline text-22px <lg:text-14px <sm:block <sm:text-12px hover:text-hex-6664D6",
        href: "https://e-rko.ru/terms_of_use.pdf"
      }, "Пользовательское соглашение"),
      _createElementVNode("a", {
        class: "underline text-22px <lg:text-14px <sm:block <sm:mt-20px <sm:text-12px <sm:ml-0 ml-175px <lg:ml-100px hover:text-hex-6664D6",
        href: "https://e-rko.ru/privacy_policy.pdf"
      }, "Согласие на обработку персональных данных")
    ], -1))
  ]))
}